export enum PaymentsStatusEnum {
  All = 0, // Alla
  Completed = 2,
  AgLowBalance = 91, // Täckning saknas
  AgNoApproval = 92, // Koppling saknas
  AgRejectedNoMandate = 93, // Avvisad – medgivande/koppling saknas
  AgCancelled = 94, // Makulerad betalning
  AgRejectedInvalidData = 95, // Avvisad – felaktiga uppgifter i underlaget
  AgRejectedMaxAmount = 96, // Avvisad – beloppet överstiger maxbeloppet
  AgWillRetry = 99, // Förnyad täckning
  SwishFailed = 101, // Misslyckad Swish Återkommande-dragning
}

export const FAILED_STATUSES = [
  PaymentsStatusEnum.AgLowBalance,
  PaymentsStatusEnum.AgNoApproval,
  PaymentsStatusEnum.AgRejectedNoMandate,
  PaymentsStatusEnum.AgCancelled,
  PaymentsStatusEnum.AgRejectedInvalidData,
  PaymentsStatusEnum.AgRejectedMaxAmount,
  PaymentsStatusEnum.AgWillRetry,
  PaymentsStatusEnum.SwishFailed,
];
